import { searchSupportersQuery } from "@/api/supporter";
import { useDebouncedQuery } from "@/api/utils";
import { saveHref } from "@/utils/assume-role";
import { Action, Command, List } from "@givenwell/command-palette";
import { BankIcon } from "@givenwell/core-solid-icons";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";

export const searchSupportersCommand: Command = {
  id: "search-supporters",
  title: "Search Supporters",
  icon: <BankIcon width="21px" height="21px" />,
  Component: ({ fallbackText }) => {
    const [searchText, setSearchText] = useState(fallbackText || "");
    const { data, isFetching } = useDebouncedQuery(searchSupportersQuery(searchText, 1, 20), 150);
    const navigate = useNavigate();
    return (
      <List
        navigationTitle="Search Supporters"
        searchText={searchText}
        onSearchTextChange={setSearchText}
        searchBarPlaceholder="Search for supporters..."
        isLoading={isFetching}
        content={
          data?.items.map(supporter => ({
            title: `${supporter.name}`,
            actions: [
              {
                title: `Assume Role`,
                onAction: ({ close }) => {
                  saveHref();
                  navigate({
                    to: "/supporter/$supporterId",
                    params: { supporterId: supporter.id },
                  });
                  close();
                },
              },
              {
                title: `Go to Admin View`,
                modifier: "shift",
                onAction: ({ close }) => {
                  navigate({
                    to: "/admin/supporters/$supporterId",
                    params: { supporterId: supporter.id },
                  });
                  close();
                },
              },
            ] satisfies Action[],
          })) || []
        }
      />
    );
  },
};
